module.exports = __webpack_public_path__ + "img/takeingVideo.0876196f.png";